export enum PaymentLinkType {
	Debit = 'debit',
	Credit = 'credit',
}